import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { ModalConfig } from './cookies-modal.config'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookies-modal',
  templateUrl: './cookies-modal.component.html',
  styleUrls: ['./cookies-modal.component.css']
})
export class CookiesModalComponent implements OnInit {

  @Input() public modalConfig?: ModalConfig
  @ViewChild('modal') private modalContent?: TemplateRef<CookiesModalComponent>
  private modalRef?: NgbModalRef

  googleIsChecked: boolean = false;

  constructor(private modalService: NgbModal, private cookieService: CookieService) { }

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalRef = this.modalService.open(this.modalContent, { centered: true, size: 'lg' })
      this.modalRef.result.then(resolve, resolve)
    })
  }

  async close(): Promise<void> {
    if (this.modalConfig!.shouldClose === undefined || (await this.modalConfig!.shouldClose())) {
      const result = this.modalConfig!.onClose === undefined || (await this.modalConfig!.onClose())
      this.modalRef!.close(result)
    }
  }

  googleCookieChanged(e) {
    this.googleIsChecked = (e.target.checked)
  }


  async saveAndClose(): Promise<void> {

    if (this.googleIsChecked) {
      this.cookieService.set('tmCookie', 'YES', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365 * 10)));
    }


    this.cookieService.set('isCookieSubmitted', 'YES', new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 365 * 10)));

    window.location.reload();

  }

  async dismiss(): Promise<void> {
    if (this.modalConfig!.shouldDismiss === undefined || (await this.modalConfig!.shouldDismiss())) {
      const result = this.modalConfig!.onDismiss === undefined || (await this.modalConfig!.onDismiss())
      this.modalRef!.dismiss(result)
    }
  }

  ngOnInit(): void {
  }

}
